import * as React from "react";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { FAQ } from "../../../models/help";
import { Grid, Row, Col } from "react-flexbox-grid";
import { sort } from "../../../utils/data";
import { Auth } from "../../../utils/auth";
import ExpansionPanel, {
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import * as s from "./faqs.css";

@observer
export default class FAQViewer extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  componentWillMount(): void {
    this.props.store.viewState.loadFAQs();
  }
  render(): JSX.Element {
    const expansionPanel: any = {
      boxShadow: "none",
      width: "100%",
    };
    const rows: JSX.Element[] = [];
    const group: string[] = [];
    this.props.store.viewState.faqs.map((faq: FAQ): void => {
      if (group.indexOf(faq.category) === -1) {
        group.push(faq.category);
      }
    });
    group.sort().map((cat: string, i: number): void => {
      const qas: JSX.Element[] = [];
      const authenticated: boolean = Auth.isAuthenticated;
      sort(this.props.store.viewState.faqs.filter((faq: FAQ): boolean => {
        return faq.category === cat;
      }), "order").map((faq: FAQ, j: number): void => {
        if ((authenticated && faq.usage === 1) || (!authenticated && faq.usage === 2)) { return; }
        const ans: string = this.props.store.viewState.convertStaticLinks(faq.a);
        qas.push(<ExpansionPanel style={expansionPanel} key={`q-${j}`} ><ExpansionPanelSummary expandIcon={<ExpandMoreIcon color="secondary" />}><Col xs={12}><p className={s.blueQuestionTitle}>{faq.q}</p></Col></ExpansionPanelSummary>);       
        qas.push(<ExpansionPanelDetails><Col key={`a-${j}`} xs={12}><div className={s.answer} dangerouslySetInnerHTML={{ __html: ans }}></div></Col></ExpansionPanelDetails></ExpansionPanel>);
        });
      rows.push(<Row key={`hdr-${i}`}><ExpansionPanel className={s.catPanel} style={expansionPanel} ><ExpansionPanelSummary expandIcon={<ExpandMoreIcon color="secondary" />}>
        <Col xs={12}><p className={s.greySubHeading}>{cat}</p></Col></ ExpansionPanelSummary><ExpansionPanelDetails ><Col xs={12}>{qas}</Col></ExpansionPanelDetails></ExpansionPanel></Row >);
    });
    
    return <Grid>{rows}</Grid>;
  }
}


// WEBPACK FOOTER //
// ./src/components/help/faqs/index.tsx